export const ENABLE_RETRY_CLOUD_IMAGE = true;
export const MAX_NUMBER_RETRY_GET_IMAGE = 3;